// Event names used when sending monitoring data to New Relic.
export const MONITORING_SAMPLE_EVENT = "monitoring_metric_sample";
export const MONITORING_SCHEMA_EVENT = "monitoring_schema_loaded";
